<template>
  <div :class="style.calendarWrapper">
    <div :class="style.calendarHeader">
      <button @click="prevMonth">&lt;</button>
      <span v-text="monthNames[currentMonth] + ' ' + currentYear" />
      <button @click="nextMonth">&gt;</button>
    </div>
    <div :class="style.calendarGrid">
      <div
        v-for="day in weekDays"
        :key="day"
        :class="style.calendarDayName"
        v-text="day"
      />

      <div
        v-for="day in daysInMonthGrid"
        :key="day.date"
        :class="getClassCalendarDay(day)"
        @click="selectDate(day.date)"
        @mouseenter="hoverDate = day.date"
        v-text="day.dayNumber"
      />
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import style from "./CalendarComponent.module.scss";
export default defineComponent({
  name: "CalendarRangePicker",
  emits: ["range"],
  data() {
    return {
      style,
      currentMonth: new Date().getMonth(),
      currentYear: new Date().getFullYear(),
      selectedStart: null as string | null,
      selectedEnd: null as string | null,
      hoverDate: null as string | null,
      weekDays: ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"],
      monthNames: [
        "Январь",
        "Февраль",
        "Март",
        "Апрель",
        "Май",
        "Июнь",
        "Июль",
        "Август",
        "Сентябрь",
        "Октябрь",
        "Ноябрь",
        "Декабрь"
      ]
    };
  },
  methods: {
    formatDate(date: Date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    },
    prevMonth() {
      if (this.currentMonth === 0) {
        this.currentMonth = 11;
        this.currentYear--;
      } else {
        this.currentMonth--;
      }
    },
    nextMonth() {
      if (this.currentMonth === 11) {
        this.currentMonth = 0;
        this.currentYear++;
      } else {
        this.currentMonth++;
      }
    },
    selectDate(date: string) {
      if (!this.selectedStart || (this.selectedStart && this.selectedEnd)) {
        this.selectedStart = date;
        this.selectedEnd = null;
      } else {
        if (date < this.selectedStart) {
          this.selectedEnd = this.selectedStart;
          this.selectedStart = date;
        } else {
          this.selectedEnd = date;
        }
        this.$emit("range", [this.selectedStart, this.selectedEnd]);
      }
    },
    isInRange(date: string) {
      if (!this.selectedStart || !date) return false;
      if (this.selectedStart && !this.selectedEnd && this.hoverDate) {
        return (
          (date >= this.selectedStart && date <= this.hoverDate) ||
          (date <= this.selectedStart && date >= this.hoverDate)
        );
      }
      if (this.selectedStart && this.selectedEnd) {
        return date >= this.selectedStart && date <= this.selectedEnd;
      }
      return false;
    },
    getClassCalendarDay({date}: {date: string}) {
      let classItem = style.calendarDay;
      if (this.isInRange(date)) {
        classItem += " " + style.inRange;
      }
      return classItem;
    }
  },
  computed: {
    daysInMonthGrid() {
      const firstDayOfMonth = new Date(this.currentYear, this.currentMonth, 1);
      const lastDayOfMonth = new Date(
        this.currentYear,
        this.currentMonth + 1,
        0
      );

      const startDay = (firstDayOfMonth.getDay() + 6) % 7; // понедельник — первый день
      const totalDays = lastDayOfMonth.getDate();

      const days: {date: string; dayNumber: number | ""}[] = [];
      for (let i = 0; i < startDay; i++) {
        days.push({date: "", dayNumber: ""});
      }
      for (let day = 1; day <= totalDays; day++) {
        const date = new Date(this.currentYear, this.currentMonth, day);
        const dateStr = this.formatDate(date);
        days.push({date: dateStr, dayNumber: day});
      }
      return days;
    }
  }
});
</script>
